import ErrorGeneric from '../../components/ErrorGeneric';
import ContactInfoVerification from '../../pages/Escalation/Otp/contactInfoVerification/index';
import ContactInfoVerificationStep1 from '../../pages/Escalation/Otp/contactInfoVerification/contactInfoVerificationStep1';
import ContactInfoVerificationOTP from '../../pages/Escalation/Otp/contactInfoVerification/contactInfoVerificationOTP';
import FeedbackOTP from '../../pages/Escalation/Otp/contactInfoVerification/contactInfoVerificationOTP/feedbackOTP';
import FeedbackContactVerification from '../../pages/Escalation/Otp/contactInfoVerification/contactInfoVerificationStep1/feedbackContactVerification/index';
import ObdCallback from '../../pages/Escalation/Onboarding/ObdCallback';
import OnboardingFirstVerification from '../../pages/Escalation/Otp/verificationMethodContact';
import ContactInfoVerified from '../../pages/Escalation/Otp/contactInfoVerified';
import ContactInfoVerified2 from '../../pages/Escalation/Otp/contactInfoVerified/contactInfoVerified2';
import ContactInfoVerifiedOTP from '../../pages/Escalation/Otp/contactInfoVerified/contactInfoVerifiedOTP';
import FeedbackOTPProcess from '../../pages/Escalation/Otp/contactInfoVerified/feedbackOTPProcess/index';
import packageJson from '../../../package.json';
import Stopper from '../../components/Stopper';
import UpdatePersonalData from '../../pages/profile/personalData/updateContacts/update';
import EscalationContactsVerify from '../../pages/Escalation/OtpNewFlow/validateOtp';
import ContactsVerify from '../../pages/profile/personalData/updateContacts/verifySend';
import ContactsValidate from '../../pages/profile/personalData/updateContacts/validateVerify';
import FeedbackContactsValidate from '../../pages/profile/personalData/updateContacts/feedback';
import { ordersRoutes } from '../../pages/profile/orders/routes';
import { configureLineRoutes } from '../../pages/ConfigureLine/routes';
import { billsRoutes } from '../../pages/bills/routes';
import { exploreRoutes } from '../../pages/explore/routes';
import { problemsRoutes } from '../../pages/support/routes';
import { profileRoutes } from '../../pages/profile/routes';
import { homeRoutes } from '../../pages/home/routes';
import { loginRoutes } from '../../pages/Login/routes';
import { logoutRoutes } from '../../pages/Logout/routes';
import { ssoRoutes } from '../../pages/SSO/routes';
import EscalationContacts from '../../pages/Escalation/OtpNewFlow/escalation';
import SelectBankAccount from '../../pages/profile/personalData/changeBankAccount';
import FeedbackChangeBankAccount from '../../pages/profile/personalData/changeBankAccount/feedbackBankAccount';
import UpdateBankAccount from '../../pages/profile/personalData/changeBankAccount/updateBankAccount';
import ObdCallback2 from '../../pages/Escalation/Onboarding/ObdCallback2';

export interface IRoute {
    path: string;
    element: JSX.Element;
}

export const baseRoutes: IRoute[] = [
    //Flujo DAON
    { path: '/obd/daon', element: <OnboardingFirstVerification /> },
    { path: '/obd/callback', element: <ObdCallback /> },
    { path: '/obd/callback/v2', element: <ObdCallback2 /> },
    { path: '/obd/verify', element: <ContactInfoVerification /> },
    { path: '/obd/verify/contacts', element: <ContactInfoVerificationStep1 /> },
    { path: '/obd/verify/feedback', element: <FeedbackContactVerification /> },
    { path: '/obd/verify/otp', element: <ContactInfoVerificationOTP /> },
    { path: '/obd/verify/otp/feedback', element: <FeedbackOTP /> },
    // FLUJO OTP
    { path: '/escalation/otp', element: <ContactInfoVerified /> },
    { path: '/escalation/otp/send', element: <ContactInfoVerified2 /> },
    { path: '/escalation/otp/verify', element: <ContactInfoVerifiedOTP /> },
    { path: '/escalation/otp/feedback', element: <FeedbackOTPProcess /> },
    //UPDATE DATA PERSONAL
    { path: '/escalation/contacts', element: <EscalationContacts /> },
    { path: '/escalation/contacts/verify', element: <EscalationContactsVerify /> },
    { path: '/update-personal-data', element: <UpdatePersonalData /> },
    { path: '/contacts/verify', element: <ContactsVerify /> },
    { path: '/select-bank-account', element: <SelectBankAccount /> },
    { path: '/update-bank-account', element: <UpdateBankAccount /> },
    { path: '/update-bank-account/feedback', element: <FeedbackChangeBankAccount /> },
    { path: '/contacts/validate', element: <ContactsValidate /> },
    { path: '/feedback/contacts/validate', element: <FeedbackContactsValidate /> },
    { path: '/stopper', element: <Stopper /> },
    { path: '/error', element: <ErrorGeneric /> },
    {
        path: '/version',
        element: (
            <>
                <div
                    style={{
                        fontSize: '50px',
                        margin: '0 auto',
                        height: '100%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    VERSION: {packageJson.version}
                </div>
            </>
        ),
    },
];

baseRoutes.push(...loginRoutes);
baseRoutes.push(...logoutRoutes);
baseRoutes.push(...ssoRoutes);
baseRoutes.push(...homeRoutes);
baseRoutes.push(...configureLineRoutes);
baseRoutes.push(...billsRoutes);
baseRoutes.push(...profileRoutes);
baseRoutes.push(...ordersRoutes);
baseRoutes.push(...exploreRoutes);
baseRoutes.push(...problemsRoutes);

export const routes = baseRoutes;
